import environment from "./base";

/*
 * base.ts is the default environment for production.
 * You shouldn't have override anything.
 */
const influencersAPI = "https://influencerclientapi.aiplex.in";

const env = environment(influencersAPI);

const productionEnv = {
  ...env,
  isProduction: true,
  isDevelopment: false,
};

export default productionEnv;
